module.exports = __webpack_public_path__ + "img/clinic_building.f4673d97.png";